<template>
<div class="infomationAddEdit">
	<div class="mask"></div>
	<div class="form">
		<div class="tit f-16 fb">
			<template v-if="itemdata.businessId">
				编辑
			</template>	
			<template v-else>
				新增
			</template>
		</div>
        <div class="item cf" v-for="(item,index) in itemdata.column">
        	<div class="name fl"><span v-if="item.rules[0].required">*</span>{{item.label}}</div>
        	<div :class="item.type=='uploadFile'?'ovh':'ovh text'">
		        <template v-if="item.type=='uploadFile'">
		          <el-upload
		          class="upload-demo"
		          :action="uploadFileUrl"
		          :headers="headers"
		          :show-file-list="true"
		          :on-success="(res,file)=>{return handleSuccess(res,file,item.model)}"
		          :on-remove="(res,file)=>{return handleRemove(res,file,item.model)}"
		          :multiple="false"
		          :file-list="itemdata.data[item.model]"
		          :before-upload="uploadFun">
		            <span class="fileInput" v-if="itemdata.data[item.model]==''">点击上传</span>
		          </el-upload>
		        </template>
		        
				<template v-else-if="item.type=='date'">
		          <el-date-picker
		            v-model="itemdata.data[item.model]"
		            :placeholder="item.options.placeholder">
		          </el-date-picker>
		        </template>

				<template v-else-if="item.type=='time'">
					<el-time-select
					  v-model="itemdata.data[item.model]"
					  :placeholder="item.options.placeholder">
					</el-time-select>
				</template>

				<template v-else-if="item.type=='select'">
		          	<el-select v-model="itemdata.data[item.model]" placeholder="请选择">
					    <el-option
					      v-for="(g,k) in item.options.options"
					      :key="g.value"
					      :label="g.text"
					      :value="g.value">
					    </el-option>
					</el-select>
		        </template>
				
				<template v-else-if="item.type=='number'">
		          <el-input type="number" v-model="itemdata.data[item.model]" :name="item.key" :placeholder="item.options.placeholder"></el-input>
		        </template>

		        <template v-else>
		          <input type="text" v-model="itemdata.data[item.model]" :name="item.key" :placeholder="item.options.placeholder">
		        </template>
	        </div>
      	</div>
      	<div class="btnBox">
			<div class="btn btn1" @click="save">保存</div>
			<div class="btn btn2" @click="cancel">取消</div>
      	</div>
	</div>
</div>
</template>
<script>
import { urlHead } from '@/utils/http'
export default {
	name: 'tableadd',
	props:{
		itemdata: {
	      	type: Object,
  			default: []
	    }
	},
	data(){
		return{
			uploadFileUrl:urlHead+'user-api/common/upload',
		    headers: {
		       'X-Access-Token':window.sessionStorage.getItem('token'), //headers属性中添加token，这个属性是el-upload自带的用来设置上传请求头部
		    }
		}
	},
	mounted(){

	},
  	methods:{
	    //上传成功
	    handleSuccess(res,file,key) {
		    let that=this
		    that.itemdata.data[key]=[{name: file.name, url: URL.createObjectURL(file.raw)}]
	    },
	    //移除
	    handleRemove(res,file,key) { 
	    	let that=this
	    	that.itemdata.data[key]=[]
	    },
	    //上传前格式校验
	    uploadFun(file){
	      let that=this
	      console.log(file.type,"file.type")
	      const isJPG = file.type === 'image/jpeg' || file.type==='image/png' || file.type==='image/jpg' || file.type==='application/pdf' || file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
	      const isLt50M = file.size / 1024 / 1024 < 50;
	      //word excel ppt
	      if (!isJPG) {
	        that.$message.error('只能上传pdf、图片、word、excel、ppt!');
	      }
	      if (!isLt50M) {
	        that.$message.error('上传头像图片大小不能超过 50MB!');
	      }
	      return isJPG && isLt50M;
	    },
	    save(){
	    	let that=this
	    	let sop=true

		    //验证，表格结构数据中有必填和校验正则
		    let column=that.itemdata.column
	        let data=that.itemdata.data
         	column.forEach((item,index)=>{
	            if (sop) {
		            if(data[item.model]==''&&item.rules[0].required){
		                sop=false
		                that.$message.error(item.label+"不能为空")
		            }else if(data[item.model]!=''&&item.rules[1]&&item.rules[1].pattern){

		                let pattern=new RegExp(item.rules[1].pattern)

		                if (!pattern.test(data[item.model])) {
		                  sop=false
		                  that.$message.error(item.label+"格式错误")
		                }
		            }
	            }
          	})
		    //通过验证传递参数
		    if (sop) {
		    	this.$emit('save',{column:that.itemdata});
		    }
	    },
	    cancel(){
	    	this.$emit('cancel'); 
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tableadd/index.vue